import * as React from "react";
import {PaymentButton} from "./shared/payment-button";
import {Alert} from "../../../../shared/alert";

export const SubscriptionExpireAlert = ({ onRenew, remainingDays }) => {
    if(remainingDays > 15) return null

    const expiresIn = remainingDays === 0 ? 'today' : 'in ' + remainingDays + ' day' + (remainingDays > 1 ? 's' : '')

    return <Alert button={<PaymentButton product="subscribe" onPay={onRenew}>Renew</PaymentButton>}>
        Your subscription expires {expiresIn}
    </Alert>

}